import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Button, Modal } from '@shared/widgets';

interface IErrorMasterKeyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ErrorMasterKeyModal = (props: IErrorMasterKeyModalProps) => {
  const { navigate } = useRouteHook();

  return (
    <Modal title='Master Key Error' isOpen={props.isOpen} onClose={props.onClose}>
      <p className='max-md:text-[#4c4c4c80]'>
        If you are having problems receiving your Master Key authentication code please contact our customer services team on the number below:
      </p>
      <div className='mt-4 mb-8 max-md:mx-6 max-md:mt-4 max-md:rounded-lg max-md:bg-[#d7c29a1a] max-md:p-2'>
        <p className='text-[#000]'>24-hour phone support:</p>
        <p className='text-[#000]'>+44-203-151-7000 / +800-800-00-700</p>
      </div>
      <Button className='mx-auto w-[159px] max-md:w-full' onClick={() => navigate(RoutePaths.masterKey.onNavigate())}>
        Ok
      </Button>
    </Modal>
  );
};
